module.exports = __webpack_public_path__ + "static/media/award.a201439f.svg";